import { ProfessionTypeEnum } from '~/models';

export const EXCLUDED_PROFESSIONS = [ProfessionTypeEnum.DN];

export const PROFESSIONAL_COUNTS = 3000000;
